'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var formMessages = (0, _reactIntl.defineMessages)({
    close: {
        'id': 'formMessages.close',
        'defaultMessage': 'Close'
    },
    congratulations: {
        'id': 'formMessages.congratulations',
        'defaultMessage': 'Congratulations!'
    },
    reqSetComplete: {
        'id': 'formMessages.reqSetComplete',
        'defaultMessage': 'This requirement is complete. Fields will be locked for editing after the due date.'
    }
}); /**
    *  formMessages is in MessageDescriptorMap format for react-intl:
    *
    *    type MessageDescriptor = {
    *        id: string,
    *        defaultMessage: string,
    *        description?: string,
    *    };
    *
    *    type MessageDescriptorMap = {[key: string]: MessageDescriptor};)
    */

exports.default = formMessages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formMessages.js
// module id = 1364
// module chunks = 0